export class InvalidUserEventException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidUserEventException';
  }
}
